import { BrandColors } from '../theme';

export const chipTokens = {
    root: {
        borderRadius: '2rem',
        paddingX: '0.75rem',
        paddingY: '0.25rem',
        gap: '0.375rem',
        background: BrandColors.surface[100],
        color: BrandColors.surface[700],
    },
    icon: {
        color: BrandColors.surface[500],
        size: '1rem',
    },
    removeIcon: {
        color: BrandColors.surface[500],
        size: '1rem',
        focusRing: {
            color: BrandColors.primary[300],
        },
    },
};
